export const ACTIVE_TAB_RECO = "boilerplate/GSTR2A2BNEWRECO/ACTIVE_TAB_RECO";
export const ACTIVE_TAB_VIEW_RECO =
  "boilerplate/GSTR2A2BNEWRECO/ACTIVE_TAB_VIEW_RECO";
export const ACTIVE_TAB_DOC_VIEW =
  "boilerplate/GSTR2A2BNEWRECO/ACTIVE_TAB_DOC_VIEW";

export const LOADER_STATUS = "boilerplate/GSTR2A2BNEWRECO/LOADER_STATUS";

export const VIEW_RECO_TABLE_DATA =
  "boilerplate/GSTR2A2BNEWRECO/VIEW_RECO_TABLE_DATA";
export const ISSUE_WISE_TABLE_DATA =
  "boilerplate/GSTR2A2BNEWRECO/ISSUE_WISE_TABLE_DATA";
export const DOC_VIEW_TABLE_DATA =
  "boilerplate/GSTR2A2BNEWRECO/DOC_VIEW_TABLE_DATA";
export const SUPPLIER_WISE_TABLE_DATA =
  "boilerplate/GSTR2A2BNEWRECO/SUPPLIER_WISE_TABLE_DATA";
export const DOWNLOAD_REPORT_TABLE_DATA =
  "boilerplate/GSTR2A2BNEWRECO/DOWNLOAD_REPORT_TABLE_DATA";
export const UPLOAD_REPORT_TABLE_DATA =
  "boilerplate/GSTR2A2BNEWRECO/UPLOAD_REPORT_TABLE_DATA";
export const RECO_HISTORY_TABLE_DATA =
  "boilerplate/GSTR2A2BNEWRECO/RECO_HISTORY_TABLE_DATA";
export const DOC_DATE_TABLE_DATA =
  "boilerplate/GSTR2A2BNEWRECO/DOC_DATE_TABLE_DATA";

export const SEARCH_STR_RECO = "boilerplate/GSTR2A2BNEWRECO/SEARCH_STR_RECO";

export const SELECTED_MATCHED = "boilerplate/GSTR2A2BNEWRECO/SELECTED_MATCHED";
export const SELECTED_PROBABLE =
  "boilerplate/GSTR2A2BNEWRECO/SELECTED_PROBABLE";
export const SELECTED_MISMATCH =
  "boilerplate/GSTR2A2BNEWRECO/SELECTED_MISMATCH";
export const SELECTED_NOTINPR = "boilerplate/GSTR2A2BNEWRECO/SELECTED_NOTINPR";
export const SELECTED_NOTINGSTN =
  "boilerplate/GSTR2A2BNEWRECO/SELECTED_NOTINGSTN";
export const SELECTED_REJECTED =
  "boilerplate/GSTR2A2BNEWRECO/SELECTED_REJECTED";

export const R_GSTIN_TAXPAYER_FILTER =
  "boilerplate/GSTR2A2BNEWRECO/R_GSTIN_TAXPAYER_FILTER";
export const S_GSTIN_TAXPAYER_FILTER =
  "boilerplate/GSTR2A2BNEWRECO/S_GSTIN_TAXPAYER_FILTER";
export const INUM_FILTER = "boilerplate/GSTR2A2BNEWRECO/INUM_FILTER";
export const MONTH_FILTER = "boilerplate/GSTR2A2BNEWRECO/MONTH_FILTER";
export const MONTH_3B_FILTER = "boilerplate/GSTR2A2BNEWRECO/MONTH_3B_FILTER";
export const BASE_DATA_FILTER = "boilerplate/GSTR2A2BNEWRECO/BASE_DATA_FILTER";
export const AVAILED_FILTER = "boilerplate/GSTR2A2BNEWRECO/AVAILED_FILTER";
export const DATE_RANGE = "boilerplate/GSTR2A2BNEWRECO/DATE_RANGE";
export const DATE_RANGE_FILTER =
  "boilerplate/GSTR2A2BNEWRECO/DATE_RANGE_FILTER";

export const TOTAL_PAGES_RECO_HISTORY =
  "boilerplate/GSTR2A2BNEWRECO/TOTAL_PAGES_RECO_HISTORY";
export const PAGE_NO_RECO_HISTORY =
  "boilerplate/GSTR2A2BNEWRECO/PAGE_NO_RECO_HISTORY";
export const SELECTION = "boilerplate/GSTR2A2BNEWRECO/SELECTION";
export const RECO_SELECTION = "boilerplate/GSTR2A2BNEWRECO/RECO_SELECTION";
export const SELECTED_YEAR = "boilerplate/GSTR2A2BNEWRECO/SELECTED_YEAR";
export const TAXABLE_VALUE = "boilerplate/GSTR2A2BNEWRECO/TAXABLE_VALUE";
export const TAX_RATE = "boilerplate/GSTR2A2BNEWRECO/TAX_RATE";

export const TOTAL_PAGES_MATCHED =
  "boilerplate/GSTR2A2BNEWRECO/TOTAL_PAGES_MATCHED";
export const TOTAL_PAGES_PROBABLE =
  "boilerplate/GSTR2A2BNEWRECO/TOTAL_PAGES_PROBABLE";
export const TOTAL_PAGES_MISMATCH =
  "boilerplate/GSTR2A2BNEWRECO/TOTAL_PAGES_MISMATCH";
export const TOTAL_PAGES_NOT_IN_PR =
  "boilerplate/GSTR2A2BNEWRECO/TOTAL_PAGES_NOT_IN_PR";
export const TOTAL_PAGES_NOT_IN_GSTN =
  "boilerplate/GSTR2A2BNEWRECO/TOTAL_PAGES_NOT_IN_GSTN";
export const TOTAL_PAGES_REJECTED =
  "boilerplate/GSTR2A2BNEWRECO/TOTAL_PAGES_REJECTED";

export const PAGE_NO_MATCHED = "boilerplate/GSTR2A2BNEWRECO/PAGE_NO_MATCHED";
export const PAGE_NO_PROBABLE = "boilerplate/GSTR2A2BNEWRECO/PAGE_NO_PROBABLE";
export const PAGE_NO_MISMATCH = "boilerplate/GSTR2A2BNEWRECO/PAGE_NO_MISMATCH";
export const PAGE_NO_NOT_IN_PR =
  "boilerplate/GSTR2A2BNEWRECO/PAGE_NO_NOT_IN_PR";
export const PAGE_NO_NOT_IN_GSTN =
  "boilerplate/GSTR2A2BNEWRECO/PAGE_NO_NOT_IN_GSTN";
export const PAGE_NO_REJECTED = "boilerplate/GSTR2A2BNEWRECO/PAGE_NO_REJECTED";

export const PAGE_NO_UPLOAD_REPORT =
  "boilerplate/GSTR2A2BNEWRECO/PAGE_NO_UPLOAD_REPORT";
export const TOTAL_PAGES_UPLOAD_REPORT =
  "boilerplate/GSTR2A2BNEWRECO/TOTAL_PAGES_UPLOAD_REPORT";
export const VENDOR_LIST = "boilerplate/GSTR2A2BNEWRECO/VENDOR_LIST";
export const SELECTED_ROW_PROBABLE =
  "boilerplate/GSTR2A2BNEWRECO/SELECTED_ROW_PROBABLE";
export const SELECTED_ROW_MISMATCH =
  "boilerplate/GSTR2A2BNEWRECO/SELECTED_ROW_MISMATCH";
export const SELECTED_ROW_NOT_IN_GSTN =
  "boilerplate/GSTR2A2BNEWRECO/SELECTED_ROW_NOT_IN_GSTN";
export const SELECTED_ROW_NOT_IN_PR =
  "boilerplate/GSTR2A2BNEWRECO/SELECTED_ROW_NOT_IN_PR";
export const SELECTED_ROW_MATCHED =
  "boilerplate/GSTR2A2BNEWRECO/SELECTED_ROW_MATCHED";
export const SELECTED_ROW_REJECTED =
  "boilerplate/GSTR2A2BNEWRECO/SELECTED_ROW_REJECTED";

export const recoType = [
  {
    label: "PR vs 2A",
    value: "PRvs2A",
  },
  {
    label: "PR vs 2B",
    value: "PRvs2B",
  },
];
export const recoBase = [
  {
    label: "Tax Period",
    value: "Tax Period",
  },
  {
    label: "Document Date",
    value: "Document Date",
  },
];
export const recoHeaders = [
  {
    value: "Reco History",
    id: "1",
  },
  {
    value: "View Reco",
    id: "2",
  },
  {
    value: "Document Date wise Reco Report",
    id: "3",
  },
];
export const ViewRecoHeaders = [
  {
    value: "Issue Wise",
    id: "1",
  },
  {
    value: "Document View",
    id: "2",
  },
  {
    value: "Supplier Wise",
    id: "3",
  },
  {
    value: "Download Report",
    id: "4",
  },
  {
    value: "Upload Report",
    id: "5",
  },
];
export const DocViewHeaders = [
  {
    value: "Matched",
    id: "1",
  },
  {
    value: "Probable Match",
    id: "2",
  },
  {
    value: "Mismatch",
    id: "3",
  },
  {
    value: "Not in PR",
    id: "4",
  },
  {
    value: "Not in GSTN",
    id: "5",
  },
  {
    value: "Rejected",
    id: "6",
  },
];
export const baseDataList = [
  {
    label: "Accepted PR",
    value: "Accepted PR",
  },
  {
    label: "Accepted GSTN",
    value: "Accepted GSTN",
  },
];
export const availedList = [
  {
    label: "Yes",
    value: "Y",
  },
  {
    label: "No",
    value: "N",
  },
];
export const typeMap = {
  pass: "PASS",
  fail: "FAIL",
  total: "TOTAL",
};
export const months = [
  {
    label: "January",
    value: "January",
  },
  {
    label: "February",
    value: "February",
  },
  {
    label: "March",
    value: "March",
  },
  {
    label: "April",
    value: "April",
  },
  {
    label: "May",
    value: "May",
  },
  {
    label: "June",
    value: "June",
  },
  {
    label: "July",
    value: "July",
  },
  {
    label: "August",
    value: "August",
  },
  {
    label: "September",
    value: "September",
  },
  {
    label: "October",
    value: "October",
  },
  {
    label: "November",
    value: "November",
  },
  {
    label: "December",
    value: "December",
  },
];
